import Modal from 'react-bootstrap/Modal';

export default function ModalEnrollment(props) {
  return (
    <div className="modal-enrolment">
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <button className="close" onClick={props.onHide}>
            <i className="fas fa-times"></i>
          </button>
          {typeof props.mapShow === 'string' &&
          props.mapShow.includes('<iframe') ? (
            <div
              className="contact-map"
              dangerouslySetInnerHTML={{ __html: props.mapShow }}
            ></div>
          ) : (
            <div className="no-contact-map">
              <p>Bản đồ không khả dụng.</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
